import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { RelewiseSearchService } from '../../../integrations/relewise/services/SearchService';
import { getByCustomerAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CommerceListsDataActions.g';
import { CommerceList } from '@msdyn365-commerce/retail-proxy';
import { WishlistResult } from '../cus-wishlist.data';

export class GetWishlistDataInput implements IActionInput {
    public getCacheKey = () => 'WishlistData';

    public getCacheObjectType = () => 'WishlistData';

    public dataCacheType = (): CacheType => 'none';
}

const createInput = (): GetWishlistDataInput => {
    return new GetWishlistDataInput();
};

export async function getWishlistData(input: GetWishlistDataInput, actionContext: IActionContext): Promise<WishlistResult | undefined> {
    if (!actionContext.requestContext.user.isAuthenticated) {
        // If user is logged out, don't do anything
        return;
    }

    let wishlistResult: CommerceList[] | undefined;
    try {
        wishlistResult = await getByCustomerAsync({ callerContext: actionContext, queryResultSettings: {} }, null);
    } catch (error) {
        const message = `[getWishlistData] Error fetching wishlist data from MS: ${error instanceof Error ? error.message : String(error)}`;
        console.error(message);
        actionContext.telemetry.error(message);
        return { hasError: true };
    }

    const wishlist = wishlistResult?.[0];
    const wishlistVariantRecordIds = wishlist?.CommerceListLines?.map(line => line?.ProductId).filter((id): id is number => Boolean(id));
    if (!wishlist || !wishlistVariantRecordIds || !wishlistVariantRecordIds.length) {
        // No errors here, empty wishlist is a happy path
        return;
    }

    const searchService = new RelewiseSearchService(actionContext.requestContext, actionContext.telemetry);
    const wishlistProducts = await searchService.findVariantsByIds(wishlistVariantRecordIds);
    if (wishlistProducts === undefined) {
        // Request failed, pass on the error state
        return { hasError: true };
    }

    if (!wishlistProducts.length) {
        // The request succeeded but returned no product.
        // That means the products are either disabled or hidden.
        return;
    }

    return {
        products: wishlistProducts,
        wishlist: wishlist
    };
}

export const getWishlistDataAction = createObservableDataAction({
    id: '@msdyn365-commerce-modules/custom/get-wishlist-data',
    action: <IAction<unknown>>getWishlistData,
    input: createInput
});

export default getWishlistDataAction;
